import script from "./ProductReviewComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductReviewComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ProductReviewComponent.vue?vue&type=style&index=0&id=1cce43fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cce43fe"]])

export default __exports__